import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import scheduleData from '../data/schedule.json';

const contentTypes = {
  blog: { label: 'Blog Post', color: '#4A90E2' },
  video: { label: 'YouTube Video', color: '#E24A62' },
  social: { label: 'LinkedIn Post', color: '#7C4AE2' }
};

const Schedule = () => {
  const [selectedTypes, setSelectedTypes] = useState(Object.keys(contentTypes));
  const [events, setEvents] = useState([]);

  useEffect(() => {
    // Filter events by selected type
    const filtered = scheduleData.events.filter(e => selectedTypes.includes(e.type));
    setEvents(filtered);
  }, [selectedTypes]);

  const toggleType = (type) => {
    setSelectedTypes((prev) =>
      prev.includes(type) ? prev.filter(t => t !== type) : [...prev, type]
    );
  };

  return (
    <div style={{ display: 'flex', padding: '2rem', fontFamily: 'sans-serif' }}>
      {/* Sidebar */}
      <div style={{ width: '250px', marginRight: '2rem' }}>
        <h3 style={{ marginBottom: '1rem' }}>Legend & Filters</h3>
        {Object.entries(contentTypes).map(([key, { label, color }]) => (
          <label key={key} style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
            <input
              type="checkbox"
              checked={selectedTypes.includes(key)}
              onChange={() => toggleType(key)}
              style={{ marginRight: '0.5rem' }}
            />
            <span
              style={{
                display: 'inline-block',
                width: '12px',
                height: '12px',
                backgroundColor: color,
                borderRadius: '2px',
                marginRight: '0.5rem'
              }}
            ></span>
            {label}
          </label>
        ))}
      </div>

      {/* Calendar */}
      <div style={{ flex: 1 }}>
        <h2 style={{ marginBottom: '1rem' }}>Content Publishing Calendar</h2>
        <p style={{ fontSize: '1rem', color: '#555', marginBottom: '2rem', maxWidth: '800px' }}>
          This calendar shows when each campaign asset is scheduled to go live across blog, video, and social platforms. Use the legend to filter content types.
        </p>

        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          headerToolbar={{
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,timeGridDay'
          }}
          height="auto"
          events={events.map(event => ({
            ...event,
            backgroundColor: contentTypes[event.type]?.color || '#ccc',
            borderColor: contentTypes[event.type]?.color || '#ccc'
          }))}
        />
      </div>
    </div>
  );
};

export default Schedule;